module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    staticStyle: {
      "min-width": "1000px"
    }
  }, [_c('card', {
    staticStyle: {
      "width": "100%",
      "height": "11%",
      "position": "absolute",
      "top": "0px"
    }
  }, [_c('div', {
    staticClass: "nav-right"
  }, [_c('Icon', {
    staticClass: "nav-icon",
    attrs: {
      "type": "person"
    }
  }), _vm._v("\n        立即注册 丨\n        "), _c('Icon', {
    staticClass: "nav-icon",
    attrs: {
      "type": "ios-analytics"
    }
  }), _vm._v(" "), _c('select', {
    staticStyle: {
      "border": "0"
    }
  }, [_c('option', {
    attrs: {
      "value": "简体中文"
    }
  }, [_vm._v("简体中文")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "繁体中文"
    }
  }, [_vm._v("繁体中文")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "英文"
    }
  }, [_vm._v("英文")])])], 1)]), _vm._v(" "), (_vm.status) ? _c('Card', {
    staticClass: "card",
    staticStyle: {
      "min-width": "300px",
      "min-height": "300px"
    }
  }, [_c('p', {
    staticClass: "login-avatar"
  }, [_vm._v("登录")]), _vm._v(" "), _c('Form', {
    ref: "loginForm",
    staticClass: "login",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.loginRule
    }
  }, [_c('FormItem', {
    key: "login-account",
    staticStyle: {
      "margin-top": "5%"
    },
    attrs: {
      "prop": "account"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "邮箱/微信号/QQ号"
    },
    model: {
      value: (_vm.loginForm.account),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "account", $$v)
      },
      expression: "loginForm.account"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "person",
      "size": "16"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('FormItem', {
    key: "login-password",
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "locked",
      "size": "14"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "remember-account"
  }, [_c('input', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "6%",
      "float": "left"
    }
  }, [_vm._v("记住账号")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("忘记账号或密码")])]), _vm._v(" "), _c('FormItem', [_c('Button', {
    staticStyle: {
      "width": "35%",
      "float": "left",
      "min-width": "100px",
      "margin-bottom": "5%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCount > 3),
      expression: "errorCount > 3"
    }],
    staticClass: "card-tip"
  }, [_c('Alert', {
    attrs: {
      "type": "error",
      "show-icon": ""
    }
  }, [_vm._v("错误次数超过3次 "), _c('router-link', {
    attrs: {
      "to": "/registe"
    }
  }, [_vm._v("注册")])], 1)], 1)], 1) : _c('Card', {
    staticClass: "card"
  }, [_c('Avatar', {
    staticClass: "registe-avatar",
    attrs: {
      "icon": "person",
      "size": "large"
    }
  }), _vm._v(" "), _c('Form', {
    ref: "registeForm",
    staticClass: "registe",
    attrs: {
      "model": _vm.registeForm,
      "rules": _vm.registeRule
    }
  }, [_c('FormItem', {
    key: "registe-account",
    attrs: {
      "prop": "account"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.registeForm.account),
      callback: function($$v) {
        _vm.$set(_vm.registeForm, "account", $$v)
      },
      expression: "registeForm.account"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "person",
      "size": "16"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('FormItem', {
    key: "registe-password",
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.registeForm.password),
      callback: function($$v) {
        _vm.$set(_vm.registeForm, "password", $$v)
      },
      expression: "registeForm.password"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "locked",
      "size": "14"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('FormItem', {
    key: "registe-confirm",
    attrs: {
      "prop": "confirm"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "确认密码"
    },
    model: {
      value: (_vm.registeForm.confirm),
      callback: function($$v) {
        _vm.$set(_vm.registeForm, "confirm", $$v)
      },
      expression: "registeForm.confirm"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "locked",
      "size": "14"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": _vm.registe
    }
  }, [_vm._v("注册")])], 1)], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "11%",
      "position": "absolute",
      "bottom": "0px",
      "background-color": "#fff"
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "flex-direction": "column",
      "list-style": "none",
      "justify-content": "center",
      "height": "100%"
    }
  }, [_c('li', {
    staticClass: "info"
  }, [_vm._v("Copyright © 2017-2021 All rights reserved 版权所有 © 无障碍科技")]), _vm._v(" "), _c('li', {
    staticClass: "info"
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/#/Integrated/recordQuery",
      "target": "_blank"
    }
  }, [_vm._v("鄂ICP备18005954号")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b3fbaee","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/views/Login.vue
// module id = 8zdW
// module chunks = 0